export default {
      id: "i-full-flash-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-full-flash",
      toString: function () {
        return this.url;
      }
    }